import { initClients } from '@/api';
import { Loadable } from '@/components/Loadable';
import {
  getConsents,
  getSalesPointConfiguration,
  setTenant,
} from '@/features/configuration/configurationActions';
import { getProfile } from '@/features/profile/profileActions';
import { useDispatch } from '@/store/utils';
import { getInitialTenant } from '@/utils/tenant';
import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';

interface AppLoaderProps {
  children: ReactNode;
}

const AppLoader = ({ children }: AppLoaderProps) => {
  const dispatch = useDispatch();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const initialize = async () => {
      const promises = [];
      const tenant = getInitialTenant();

      await initClients();

      promises.push(
        dispatch(getSalesPointConfiguration()),
        dispatch(getConsents()),
        dispatch(getProfile()),
        dispatch(setTenant(tenant))
      );

      await Promise.all(promises);

      setIsInitialized(true);
    };

    initialize();
  }, [dispatch]);

  return (
    <Loadable loading={!isInitialized} className={{ regular: 'h-screen' }}>
      {children}
    </Loadable>
  );
};

export default AppLoader;
